<template>
  <el-table
    :data="integralDetails"
    border
    style="width: 100%"
    class="table">
    <el-table-column
      prop="detailId"
      :label="$t('integralDetail.id')"
      align="center"
      width="80">
    </el-table-column>
    <el-table-column
      prop="integralName"
      :label="$t('integralDetail.accountName')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="integralId"
      :label="$t('integralDetail.accountId')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="detailType"
      :label="$t('integralDetail.type')"
      align="center">
      <template slot-scope="scope">
        {{ scope.row.detailType == '2002' ? $t('integralDetail.transferOut') : $t('integralDetail.transferIn') }}
      </template>
    </el-table-column>
    <el-table-column
      prop="relIntegralId"
      :label="$t('integralDetail.relatedAccount')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="amount"
      :label="$t('integralDetail.points')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="objType"
      :label="$t('integralDetail.objType')"
      align="center">
      <template slot-scope="scope">
        {{ scope.row.objType == '7007' ? $t('integralDetail.merchant') : $t('integralDetail.user') }}
      </template>
    </el-table-column>
    <el-table-column
      prop="objId"
      :label="$t('integralDetail.objId')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="link"
      :label="$t('integralDetail.phone')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="orderId"
      :label="$t('integralDetail.orderNo')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="createTime"
      :label="$t('integralDetail.transactionTime')"
      align="center">
    </el-table-column>
    <el-table-column
      prop="remark"
      :label="$t('integralDetail.remark')"
      align="center">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'IntegralDetailTable',
  props: {
    integralDetails: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>